import React from 'react';
import LoginCarousel from './component/carousel';
import RecoverForm from './component/form';
import useUser from 'hook/user';
import { useHistory } from 'react-router-dom';
import { ModalEmailalert } from 'page/recoverEmail/component/modalEmails';

const logo = require('asset/image/logo.png');

export default function RecoverPassWordPage() {
  const { getEmailUsers, loading, status, data, msg, setMsg } = useUser();
  const history = useHistory();

  const onSubmit = (data) => {
    getEmailUsers({ cpf: data.cpf });
  };

  const [modalEmailsx, setModalEmailsx] = React.useState(false);

  React.useEffect(() => {
    if (msg !== '' && status === 200) {
      setModalEmailsx(true);
    }
  }, [msg]);

  const handleCloseModal = () => {
    history.goBack();
    setMsg('');
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Carrossel */}
      <div className="hidden md:flex w-1/2 items-center justify-center bg-primary bg-onboard_bg_img bg-cover bg-center">
        <LoginCarousel />
      </div>
      <div className="flex w-full md:w-1/2 items-center justify-center px-6 py-8">
        <div className="w-full max-w-[400px]">
          <img
            src={logo}
            alt="Logo"
            className="mb-11 h-20 w-full object-contain"
          />
          <RecoverForm
            handleSubmit={onSubmit}
            error={null}
            loading={loading}
            status={status}
          />
        </div>
      </div>
      <ModalEmailalert
        messageTitleAlert={
          msg === 'Query made successfully'
            ? 'Seus emails são os seguintes'
            : 'Não possui este cpf cadastrado'
        }
        options={data.length > 0 ? data : []}
        openSendFinish={modalEmailsx}
        handleCloseSendFinish={handleCloseModal}
        error={msg !== 'Query made successfully'}
      />
    </div>
  );
}
